// extracted by mini-css-extract-plugin
module.exports = {"theaterNameForm":"ClientCreatePasswordForm_theaterNameForm__27Q37","warning":"ClientCreatePasswordForm_warning__1b752","input":"ClientCreatePasswordForm_input__1ruYG"};